import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { cleanUrlFromDownloadParams } from '../helper/url';

export interface UseDownloadTriggerOptions {
  onTriggerDownload: (params: { guid: string; id: string }) => void;
  enabled?: boolean;
}

export function useDownloadTrigger(options: UseDownloadTriggerOptions): void {
  const { onTriggerDownload, enabled = true } = options;
  const router = useRouter();

  useEffect(() => {
    // Only run when router is ready and feature is enabled
    if (!router.isReady || !enabled) {
      return;
    }

    const { triggerDownload, guid, id } = router.query;

    // Check if download should be triggered
    if (triggerDownload === 'true') {
      // Validate that required params are present
      if (!guid || !id) {
        console.warn('[useDownloadTrigger] Missing required params (guid or id)');
        // Clean URL even if params are missing
        const cleanUrl = cleanUrlFromDownloadParams(router.asPath);
        router.replace(cleanUrl, undefined, { shallow: true });
        return;
      }

      // Type check for safety
      if (typeof guid !== 'string' || typeof id !== 'string') {
        console.warn('[useDownloadTrigger] Invalid param types');
        const cleanUrl = cleanUrlFromDownloadParams(router.asPath);
        router.replace(cleanUrl, undefined, { shallow: true });
        return;
      }

      // Trigger the download callback
      onTriggerDownload({ guid, id });

      // Clean URL params after triggering
      const cleanUrl = cleanUrlFromDownloadParams(router.asPath);
      router.replace(cleanUrl, undefined, { shallow: true });
    }
  }, [router.isReady, router.query, router.asPath, onTriggerDownload, enabled]);
}
